module.exports = __webpack_public_path__ + "img/fuwuicon.454ce615.png";